import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';
import { Header, Table } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { observer } from 'mobx-react-lite';
import HistoryPagination from '../Details/HistoryDetails/pagination/HistoryPagination';

function OrderInfomation() {
  const { activityStore } = useStore();
  const {
    loadUserTracker,
    loadMovementHistory,
    OrderTabCount,
    OrderModelTab,
    orderTabload,
    AssetsOrderInfomation,
    selectedActivity: activity,
  } = activityStore;
  const [currentPage, setCurrentPage] = useState(1);
  const [post, setPosts] = useState<any[]>([]);
  const [postsPerPage] = useState(4);
  const [loadingd, setLoadingd] = useState(true);

  useEffect(() => {
    if (loadingd) {
      setTimeout(() => {
        setLoadingd(false);
      }, 250);
    }
  }, [loadingd]);

  useEffect(() => {
    loadUserTracker(activity?.id);
    loadMovementHistory(activity?.id);
    OrderTabCount(activity?.id);
    // eslint-disable-next-line
  }, [activity, activity?.id, AssetsOrderInfomation]);

  useEffect(() => {
    setPosts(activityStore.AssetsOrderInfomation);
  }, [activityStore.AssetsOrderInfomation, activityStore.orderHistoryCount]);

  useEffect(() => {
    OrderModelTab(activity?.id, currentPage || 1);
    // eslint-disable-next-line
  }, [activity?.id, currentPage]);

  const dataShow = (
    <Table basic="very" celled collapsing columns={16}>
      <Table.Body>
        {AssetsOrderInfomation?.map((a: any) => {
          return (
            <Table.Row key={a?.id}>
              <Table.Cell width={2}>
                <Header as="h4" image>
                  <Header.Content>
                    {a?.username}
                    <Header.Subheader style={{ marginLeft: '10px' }}>
                      {activityStore.updateDateTime()}
                    </Header.Subheader>
                  </Header.Content>
                </Header>
              </Table.Cell>
              <Table.Cell width={9}>{a.status}</Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
  if (loadingd) return <LoadingComponent />;

  return (
    <div>
      {orderTabload ? (
        <LoadingComponent />
      ) : post.length !== 0 ? (
        <div>
          <div className="orders-tabs-header">{dataShow}</div>
          <div className="orders-tabs-footer">
            <div>
              <HistoryPagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={activityStore.orderHistoryCount}
                pageSize={postsPerPage}
                onPageChange={(pageNumber: number) => {
                  setCurrentPage(pageNumber);
                  OrderModelTab(activity?.id, pageNumber);
                  activityStore.orderTabCurrentpage = pageNumber;
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <p style={{ textAlign: 'center', marginTop: '150px' }}>
          No Orders Assets Found
        </p>
      )}
    </div>
  );
}
export default observer(OrderInfomation);
